import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { SupportTypeCellRenderer } from "../column-def-cell-renderers/SupportTypeCellRenderer";
import { NodeCountCell } from "../column-def-cell-renderers/NodeCountCellRenderer";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceUnusedSinceCellRenderer } from "../common/resourceUnusedSinceCellRenderer";
import {
  FilteredEbsResourceItem,
  FilteredRdsResourceItem,
} from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const rdsColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Database Id", "db_id"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("rds"),

  {
    field: "resource.support_type",
    headerName: "Support Type",
    cellRenderer: ({ data }: ICellRendererParams<FilteredRdsResourceItem>) => {
      return (
        <SupportTypeCellRenderer supportType={data?.resource?.support_type} />
      );
    },
  },

  resourceAccountColumnDef,

  resourceUnusedSinceCellRenderer,

  {
    field: "resource.is_encrypted",
    headerName: "Encryption",
    valueGetter: ({ data }) => {
      return data?.resource?.is_encrypted ? "Encrypted" : "Unencrypted";
    },
    cellRenderer: ({ data }: ICellRendererParams<FilteredEbsResourceItem>) => {
      return data?.resource?.is_encrypted ? "Encrypted" : "Unencrypted";
    },
  },

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "rds"),
  getResourceMetricsColumnDef("Connections", "total_connection_sum", "rds"),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.instance_type", headerName: "Instance Type" },
  { field: "resource.db_type", headerName: "Database Type" },

  {
    field: "resource.nodes_count",
    headerName: "Node count",
    cellRenderer: ({ data }: ICellRendererParams<FilteredRdsResourceItem>) => {
      return <NodeCountCell count={data?.resource?.nodes_count} />;
    },
  },

  { field: "resource.status", headerName: "Status" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
